import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { applyMenuOverrides, AdminCardapio } from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';

if (isAdmin) {
  root.render(<AdminCardapio />);
} else {
  // Apply the owner's ingredient changes before the first render; never block
  // the menu for long if the endpoint is slow or storage is not connected.
  const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timer = setTimeout(() => ctrl && ctrl.abort(), 2500);
  fetch('/api/menu', ctrl ? { signal: ctrl.signal } : undefined)
    .then(r => (r.ok ? r.json() : null))
    .then(d => { try { applyMenuOverrides(d && d.overrides); } catch (e) {} })
    .catch(() => {})
    .finally(() => { clearTimeout(timer); root.render(<App />); });
}
